(()=>{
  const root=document.getElementById('yy-yeti-widget-hub');
  if(!root||root.dataset.productionGuardV43Bound==='1')return;
  root.dataset.productionGuardV43Bound='1';

  const raw=String(root.dataset.whatsapp||'').replace(/\D/g,'');
  const hasWhatsApp=raw.length>=10;

  if(!hasWhatsApp){
    root.dataset.supportEnabled='false';

    const hideSelectors=[
      '[data-yy-guide="support"]',
      '[data-yy-open-support]',
      '[data-yy-action="support"]',
      '[data-yy-whatsapp-card]'
    ];

    hideSelectors.forEach(selector=>{
      root.querySelectorAll(selector).forEach(node=>{
        node.hidden=true;
        node.setAttribute('aria-hidden','true');
      });
    });

    root.querySelectorAll('.yy-ai-hint').forEach(node=>{
      node.textContent='Fitness • Yoga • Gear • Motivation';
    });

    root.querySelectorAll('.yy-chip-button').forEach(node=>{
      if(/whatsapp|support/i.test(node.textContent||'')){
        node.hidden=true;
        node.setAttribute('aria-hidden','true');
      }
    });
  }

  document.dispatchEvent(new CustomEvent('yeti:production-guard-ready',{
    detail:{version:43,whatsappReady:hasWhatsApp}
  }));
})();